import React from 'react';
import PropTypes from 'prop-types';
import { Col, KeyValue, Row } from '@folio/stripes/components';
import { FormattedMessage, useIntl } from 'react-intl';
import { Accordion, Icon, Loading } from '@folio/stripes-components';
import useTemplate from '../../../hooks/useTemplate';
import FieldViewBuilder from '../../../shared/FieldViewBuilder';
import DataProvider from '../../../providers/DataProvider';
import HelpeProvider from '../../../providers/HelpeProvider';

function ViewInstance({ instance, inventoryTemplates }) {
  const { currentTemplate, isLoading } = useTemplate(instance.templateTypeId);
  const intl = useIntl();
  const localizedTemplateName = currentTemplate?.name?.find(
    (field) => field?.locale === intl.locale,
  )?.value;

  return (
    <DataProvider>
      <HelpeProvider>
        {isLoading && <Loading size="large" />}
        {!isLoading && (
          <>
            <Accordion
              id="templateType"
              label={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.instanceWizard.instanceData.fields.templateType.label"
                  defaultMessage="Template type"
                />
              }
            >
              <Row>
                <Col xs={12}>
                  <Icon icon={currentTemplate.icon || 'document'}>
                    {localizedTemplateName}
                  </Icon>
                </Col>
              </Row>
            </Accordion>

            <FieldViewBuilder
              data={instance}
              template={currentTemplate}
              entityType="instance"
            />
          </>
        )}
      </HelpeProvider>
    </DataProvider>
  );
}

ViewInstance.propTypes = {
  instance: PropTypes.object,
  inventoryTemplates: PropTypes.arrayOf(PropTypes.object),
};

export default ViewInstance;
